import React from "react";

const Alot = () => {
  return (
    <div className="w-11/12 md:w-10/12 h-auto py-20 m-auto">
      <h3 className="w-full md:w-8/12 text-6xl font-bold bg-gradient-to-r from-startFirstText to-endFirstText inline-block text-transparent bg-clip-text">
        A lot is happening, <br />
        We are blogging about it.
      </h3>
    </div>
  );
};

export default Alot;
